import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { NavItem, NavEntryPoint } from '@retailer-platform/dashboard/routing'
import { storefrontOnboardingAccessControl } from './access-control/storefrontOnboardingAccess.configuration'
import { storefrontOnboardingRouter } from './routing/storefrontOnboardingRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'storefront-onboarding',
  totem: {
    // The default IPP tool of all routes in this domain - should match the Navigation Entry in IPP UI.
    // Individual routes can override this by specifying a `tool` prop on their DomainRoute component
    tool: 'storefront-onboarding-dashboard-tool',
  },
  routes,
  translations: { EN_US },
  lazyTranslations: {
    ES_ES: () => import('./translations/es-ES.json'),
    FR_FR: () => import('./translations/fr-FR.json'),
  },
  routers: {
    scoped: [storefrontOnboardingRouter],
  },
  navigationEntries: [
    {
      attachTo: NavItem.Storefront,
      attachToV2: NavEntryPoint.UserMenuSettings,
      subNavItems: [
        {
          type: 'item',
          llmDescription: 'Storefront onboarding guide for Android app',
          labelId: 'storefrontOnboardingDomain.android.nav',
          route: 'storefront-onboarding-android',
          accessControl: storefrontOnboardingAccessControl,
          id: 'storefront-onboarding-android',
          positionNavV2: 5,
        },
        {
          type: 'item',
          llmDescription: 'Storefront onboarding guide for iOS app',
          labelId: 'storefrontOnboardingDomain.ios.nav',
          route: 'storefront-onboarding-ios',
          accessControl: storefrontOnboardingAccessControl,
          id: 'storefront-onboarding-ios',
          positionNavV2: 4,
        },
        {
          type: 'item',
          llmDescription: 'Storefront onboarding guide for web platform',
          labelId: 'storefrontOnboardingDomain.web.nav',
          route: 'storefront-onboarding-web',
          accessControl: storefrontOnboardingAccessControl,
          id: 'storefront-onboarding-web',
          positionNavV2: 6,
        },
      ],
    },
  ],
  adminNavigationEntries: [],
}

export default definition
